import { gql } from "@apollo/client"

export const UPLOAD_FIELDS = gql`
  fragment UploadFields on UploadInfo {
    id
    key
    fileName
    fileGroup
    fileSize
    contentType
    customSize {
      width
    }
  }
`
export const KNOWLEDGE_CONTENT_FIELDS = gql`
  fragment KnowledgeContentFields on KnowledgeTrainingModule {
    id
    content {
      ... on KnowledgeContentText {
        id
        heading
        text
        textUploads {
          ...UploadFields
        }
      }
      ... on KnowledgeContentImage {
        id
        heading
        imageUploads {
          ...UploadFields
        }
      }
      ... on KnowledgeContentFiles {
        id
        heading
        fileUploads {
          ...UploadFields
        }
      }
      ... on KnowledgeContentNote {
        id
        heading
        type
        text
      }
      ... on KnowledgeContentVideo {
        id
        heading
        url
      }
    }
  }
  ${UPLOAD_FIELDS}
`
